import { Lock, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export function PaywallPrompt({ message }) {
  return (
    <div className="rounded-2xl border border-border bg-card px-8 py-10 flex flex-col items-center text-center max-w-md mx-auto mt-6">
      <div className="w-12 h-12 rounded-xl bg-muted flex items-center justify-center mb-4">
        <Lock size={20} className="text-muted-foreground" />
      </div>
      <h2 className="font-display text-xl font-normal text-foreground mb-2">School Plan Required</h2>
      <p className="text-sm text-muted-foreground leading-relaxed mb-6">
        {message ?? "This feature is available on the School plan. Your admin can set up a subscription from the School Plan page."}
      </p>
      <Link
        to="/schools/seats"
        className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary text-primary-foreground text-sm font-medium rounded-lg transition-[background,transform] duration-150 hover:opacity-90 hover:-translate-y-px"
      >
        View School Plan <ArrowRight size={14} />
      </Link>
    </div>
  );
}
